// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateCriteriaValidity = data => ({
    data,
    type: actions.UPDATE_CRITERIA_VALIDITY
});



// WEBPACK FOOTER //
// ./src/reports/shared/action-creators/criteria-validity.js